import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import FooterWrapper from '../components/FooterWrapper';
import circleCheckicon from '../assets/pricing/circle-check.svg';
import timeline from '../assets/pricing/ablauf_timeline_new.svg';
import scanSearchicon from '../assets/about/scan-search.svg';
import lightbulbicon from '../assets/about/lightbulb.svg';
import handshakeicon from '../assets/about/handshake.svg';
import rocketicon from '../assets/about/rocket.svg';
import buttonarrowright from '../assets/icons/button-arrow-right.svg';
// Import your form component
import AIPricingFormEntry from '../form/AIPricingFormEntry';

const Pricing = () => {
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  return (
    <div className="min-h-screen bg-black-pure flex flex-col">
      {/* Remove NavigationWrapper since it's already included in App.jsx */}

      {/* Section 1: Hero */}
      <section className="min-h-screen bg-[#010003] pt-20 md:pt-24 flex justify-center relative overflow-visible">
        {/* Radial Gradient Blur */}
        <div 
          className="absolute z-0 bottom-[10px] md:bottom-[25px] right-[50px] md:right-[150px] w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.15)_0%,rgba(120,124,135,0)_70%)] rounded-full blur-2xl"
          aria-hidden="true"
        />
        {/* Gradient Blur Effect */}
        <div className="absolute inset-0 z-0 pointer-events-none -top-1/4">
          <div className="absolute top-[150px] md:top-225 right-[10px] md:right-25 -translate-x-1/2 -translate-y-1/2 w-[300px] md:w-[500px] h-[300px] md:h-[500px] rounded-full bg-gradient-to-r from-white/10 via-[#d5d8f6]/10 to-white/10 blur-3xl opacity-50"></div>
        </div>
        {/* Gradient Blur Effect */}
        <div className="absolute inset-0 z-0 pointer-events-none -top-1/4">
          <div className="absolute top-[100px] md:top-150 left-[50px] md:left-125 -translate-x-1/2 -translate-y-1/2 w-[300px] md:w-[500px] h-[300px] md:h-[500px] rounded-full bg-gradient-to-r from-white/10 via-[#d5d8f6]/10 to-white/10 blur-3xl opacity-50"></div>
        </div>
        {/* Gradient Blur Effect */}
        <div className="absolute inset-0 z-0 pointer-events-none -top-1/4">
          <div className="absolute top-[150px] md:top-195 left-[100px] md:left-230 -translate-x-1/2 -translate-y-1/2 w-[350px] md:w-[600px] h-[350px] md:h-[600px] rounded-full bg-gradient-to-r from-white/10 via-[#d5d8f6]/10 to-white/10 blur-3xl opacity-50"></div>
        </div>
        <div className="w-full max-w-[1280px] px-4 pt-16 md:pt-30 relative z-0">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
            {/* Left Column */}
            <div className="flex flex-col pt-8 md:pt-12">
              <h1 className="font-calsans text-[36px] md:text-[56px] font-semibold text-white mb-4 md:mb-6 text-left leading-tight">
                Individuelle Preise,
                <br />
                maßgeschneidert
                <br />
                für Ihr Unternehmen
              </h1>
              <p className="font-geist text-[14px] md:text-[16px] font-normal text-[#787c87] mb-6 md:mb-8 max-w-[460px]">
              Unsere Consulting- und KI-Automations Lösungen bieten eine ganzheitliche Unterstützung. Von der Strategie bis zur Umsetzung, mit voller Transparenz und laufendem Support.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <img src={circleCheckicon} alt="Check" className="mt-1 flex-shrink-0 w-5 h-5" />
                  <p className="font-geist text-[14px] md:text-[16px] font-normal text-[#787c87]">
                    Strategische KI-Beratung & Roadmap für nachhaltige Transformation
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <img src={circleCheckicon} alt="Check" className="mt-1 flex-shrink-0 w-5 h-5" />
                  <p className="font-geist text-[14px] md:text-[16px] font-normal text-[#787c87]">
                    Flexible Preise nach Use-Cases, Projektumfang & Nutzerzahl
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <img src={circleCheckicon} alt="Check" className="mt-1 flex-shrink-0 w-5 h-5" />
                  <p className="font-geist text-[14px] md:text-[16px] font-normal text-[#787c87]">
                    Nahtlose Integration in bestehende Systeme & Prozesse
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <img src={circleCheckicon} alt="Check" className="mt-1 flex-shrink-0 w-5 h-5" />
                  <p className="font-geist text-[14px] md:text-[16px] font-normal text-[#787c87]">
                    Persönliches Onboarding & maßgeschneiderte Implementierung
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column - WITH YOUR FORM */}
            <div className="flex justify-center lg:justify-end relative z-10">
              <div className="w-full max-w-[500px] md:max-w-[500px] sm:max-w-full">
                {/* Your AI Pricing Form goes here */}
                <AIPricingFormEntry />
              </div>
            </div>
            
          </div>
        </div>
      </section>

        {/* Section 2: Timeline */}
        <section className="min-h-screen flex flex-col items-center bg-[#010003] pt-0 md:pt-24">
        {/* Timeline Container */}
        <div className="w-full max-w-[1440px] mt-40 px-4 pb-20 md:pb-40">
          <div className="relative">
            {/* Timeline Items - Stacked on mobile, horizontal on desktop */}
            <div className="flex flex-col space-y-16 md:space-y-0">
              {/* Item 1 - Analyse & Beratung */}
              <div className="text-left md:absolute md:top-full md:left-[82px] md:-mt-24 md:max-w-[350px]">
                <p className="font-geist text-sm tracking-[0.02em] font-light text-[#787c87] pb-2">01</p>
                <p className="font-geist text-base tracking-[0.02em] text-white pb-2">Analyse & Beratung</p>
                <p className="font-geist text-sm tracking-[0.02em] font-light text-[#787c87]">Viele Unternehmen möchten KI integrieren, wissen aber nicht, welche Bereiche wirklich sinnvoll automatisiert werden können. Wir beginnen mit einer strategischen Beratung und analysieren gemeinsam Ihre Routinetätigkeiten, um herauszufinden, wo KI den größten Mehrwert schafft.</p>
              </div>
              
              {/* Item 2 - Proof of Concept */}
              <div className="text-left md:absolute md:bottom-full md:left-[408px] md:-mb-20 md:max-w-[340px]">
                <p className="font-geist text-sm tracking-[0.02em] font-light text-[#787c87] pb-2">02</p>
                <p className="font-geist text-base tracking-[0.02em] text-white pb-2">Proof of Concept (PoC) aufsetzen</p>
                <p className="font-geist text-sm tracking-[0.02em] font-light text-[#787c87]">Bevor wir die Automatisierung vollständig implementieren, testen wir die Lösung in einem kleinen Rahmen. So stellen wir sicher, dass Prozesse fehlerfrei funktionieren und optimal auf Ihre Anforderungen abgestimmt sind.</p>
              </div>
              
              {/* Item 3 - Implementierung */}
              <div className="text-left md:absolute md:top-full md:left-[728px] md:-mt-24 md:max-w-[340px]">
                <p className="font-geist text-sm tracking-[0.02em] font-light text-[#787c87] pb-2">03</p>
                <p className="font-geist text-base tracking-[0.02em] text-white pb-2">Implementierung der KI-Lösungen</p>
                <p className="font-geist text-sm tracking-[0.02em] font-light text-[#787c87]">Nach erfolgreichem Proof of Concept bringen wir die Automatisierung in den Live-Betrieb. Dabei integrieren wir die KI-Lösungen nahtlos in Ihre bestehenden Systeme und Arbeitsprozesse. Wir achten darauf, dass die Implementierung genau auf Ihre Unternehmensstruktur zugeschnitten ist.</p>
              </div>
              
              {/* Item 4 - Kontinuierliche Optimierung */}
              <div className="text-left md:absolute md:bottom-full md:left-[1051px] md:-mb-20 md:max-w-[340px]">
                <p className="font-geist text-sm tracking-[0.02em] font-light text-[#787c87] pb-2">04</p>
                <p className="font-geist text-base tracking-[0.02em] text-white pb-2">Kontinuierliche Optimierung & Support</p>
                <p className="font-geist text-sm tracking-[0.02em] font-light text-[#787c87]">KI ist kein einmaliges Projekt. Wir begleiten Sie langfristig, überwachen die Systeme, nehmen Anpassungen vor und verbessern die Automatisierungen kontinuierlich, um nachhaltigen Erfolg zu sichern.</p>
              </div>
            </div>
            
            {/* Timeline Image - Visible on both desktop and mobile */}
            <img 
              src={timeline} 
              alt="Timeline" 
              className="w-full h-[300px] object-contain"
            />
          </div>
        </div>
      </section>

      {/* Section 3: How we work */}
      <section className="flex items-center justify-center bg-[#010003] py-0 md:py-20 h-auto md:h-[500px]"> 
        {/* Gradient Blur Effect */}
        <div className="absolute inset-0 z-0 pointer-events-none -top-1/12">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] md:w-[1640px] h-[300px] md:h-[800px] rounded-full bg-gradient-to-r from-white/5 via-[#787c87]/15 to-white/5 blur-3xl opacity-50"></div>
        </div>

        <div className="w-full max-w-[1320px] mx-auto px-4">
          {/* Heading and Description */}
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-calsans text-[24px] md:text-[42px] font-medium text-white mb-4 md:mb-6">So arbeiten wir gemeinsam für Ihren Erfolg. <br className="hidden md:block"/>Transparent, Innovativ und Kundenorientiert.</h2>
          </div>

          {/* Value Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-0 md:gap-0">
            {/* Value 1 */}
            <div className="rounded-xl p-6 h-auto md:h-[280px] flex flex-col sm:p-4">
              <div className="w-12 h-12 rounded-lg flex items-center justify-left mb-2">
                <img src={scanSearchicon} alt="Transparenz" className="w-6 h-6" />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3">Transparenz</h3>
              <p className="text-[#787c87] text-sm">
                Klare Kommunikation und nachvollzieh-<br/>bare Preise. Sie wissen jederzeit, wo Sie stehen und was Sie erwarten können.
              </p>
            </div>

            {/* Value 2 */}
            <div className="rounded-xl p-6 h-auto md:h-[280px] flex flex-col sm:p-4">
              <div className="w-12 h-12 flex items-center justify-left mb-2">
                <img src={lightbulbicon} alt="Innovation" className="w-6 h-6" />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3">Innovation</h3>
              <p className="text-[#787c87] text-sm">
                Wir setzen auf modernste KI-Technologien und entwickeln zukunftsorientierte Lösungen, die echten Mehrwert schaffen.
              </p>
            </div>

            {/* Value 3 */}
            <div className="rounded-xl p-6 h-auto md:h-[280px] flex flex-col sm:p-4">
              <div className="w-12 h-12 rounded-lg flex items-center justify-left mb-2">
                <img src={handshakeicon} alt="Vertrauen" className="w-6 h-6" />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3">Vertrauen</h3>
              <p className="text-[#787c87] text-sm">
                Partnerschaft auf Augenhöhe: Wir begleiten Sie langfristig und zuverlässig bei Ihrer Transformation.
              </p>
            </div>

            {/* Value 4 */}
            <div className="rounded-xl p-6 h-auto md:h-[280px] flex flex-col sm:p-4">
              <div className="w-12 h-12 rounded-lg flex items-center justify-left mb-2">
                <img src={rocketicon} alt="Kundenfokus" className="w-6 h-6" />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3">Kundenfokus</h3>
              <p className="text-[#787c87] text-sm">
                Ihre Ziele stehen im Mittelpunkt. Wir entwickeln maßgeschneiderte Strategien, die genau zu Ihrem Business passen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: FAQ */}
      <section className="min-h-screen flex items-center justify-center bg-[#010003] py-16 md:py-20 pt-32 md:pt-64">
        <div className="w-full max-w-[1280px] mx-auto px-4">
          <div className="flex flex-col md:flex-row gap-8 md:gap-12">
            {/* Left Column - 1/3 width */}
            <div className="w-full md:w-1/3">
              <h2 className="font-calsans text-[24px] md:text-[42px] font-semibold text-white mb-6">Ihre Fragen - unsere Antworten</h2>
            </div>
            
            {/* Right Column - 2/3 width with FAQ */}
            <div className="w-full md:w-2/3">
              <div className="pt-0 pb-12 md:pb-16">
                {[
                  {
                    question: "Welche Prozesse eignen sich für KI-Automatisierung?",
                    answer: "KI eignet sich besonders für wiederkehrende Prozesse, die viele Daten, Texte oder Zahlen enthalten. Prozesse, die stark individuell oder komplexes Fachwissen erfordern, lassen sich nur eingeschränkt automatisieren. Als Faustregel: Je einfacher und standardisierter ein Prozess, desto besser eignet er sich für eine KI-Lösung."
                  },
                  {
                    question: "Wie steigert KI die Produktivität?",
                    answer: "KI-Tools helfen, Aufgaben effizienter zu erledigen. Sie können E-Mails, Angebote, To-Do-Listen oder Reports automatisch erstellen und personalisieren. So sparen Sie Zeit, Ressourcen und erhöhen die Wettbewerbsfähigkeit Ihres Unternehmens."
                  },
                  {
                    question: "Wer kann von KI profitieren?",
                    answer: "Nicht nur große Unternehmen: Dank kostengünstiger und öffentlich zugänglicher Tools können auch kleine und mittlere Betriebe KI schnell implementieren. Die Integration erfolgt oft innerhalb weniger Stunden oder Tage – ideal, um Prozesse effizienter zu gestalten und Wettbewerbsvorteile zu sichern."
                  },
                  {
                    question: "Test-Phase & Proof of Concept",
                    answer: "Vor der vollständigen Umsetzung testen wir Ihre Automatisierung in einem kleinen Rahmen. Sollte die erwartete Qualität nicht erreicht werden, wird das Projekt abgebrochen. Verrechnet wird nur der Aufwand für die Testphase."
                  },
                  {
                    question: "Wie setzen wir Projekte um?",
                    answer: "Nach erfolgreichem Test implementieren wir die KI-Lösungen nahtlos in Ihre Systeme. Wir begleiten Ihr Team durch die Einführung, sorgen für Schulungen und stellen sicher, dass die Automatisierung effizient, skalierbar und zuverlässig läuft."
                  },
                  {
                    question: "Kosten & Preisgestaltung",
                    answer: "Die Preise richten sich nach Prozessumfang, Anzahl der Aktionen der KI und der Komplexität der Implementierung. Grundsätzlich bestehen die Kosten aus: \n\n• Einmaliger Set-Up-Gebühr\n• Monatlicher Wartungsgebühr\n• Optional: Gebühr für die Ausführung des Prozesses\n\nEin kostenloses Erstgespräch hilft, Ihre individuellen Anforderungen zu klären."
                  },
                  {
                    question: "Förderung von KI-Projekten",
                    answer: "Es gibt nationale und regionale Förderprogramme, z. B. WKO-Förderungen in Oberösterreich oder Unterstützung durch den Austria Wirtschaftsservice (AWS). Auch die FFG unterstützt KI-Projekte im Forschungsbereich."
                  },
                  {
                    question: "Gibt es eine Mindestvertragslaufzeit?",
                    answer: "Unsere Verträge sind flexibel gestaltet und richten sich nach Ihren Bedürfnissen. Wir bieten sowohl Projekt-basierte Zusammenarbeit als auch laufende Betreuung mit monatlicher Laufzeit an."
                  },
                  {
                    question: "Welche Zahlungsmodalitäten bieten Sie an?",
                    answer: "Wir bieten flexible Zahlungsbedingungen an, darunter monatliche Raten oder Einmalzahlungen. Für größere Projekte erstellen wir individuelle Zahlungspläne."
                  }
                ].map((item, index) => (
                  <div 
                    key={index} 
                    className="faq-drawer overflow-hidden"
                  >
                    <div className={`relative ${index === 0 ? 'border-t border-[rgba(120,124,135,0.25)]' : ''} border-b border-[rgba(120,124,135,0.25)]`}>
                      <button
                        className="faq-drawer__title py-5 md:py-6 block w-full text-left cursor-pointer text-sm md:text-base font-normal text-white font-geist relative pr-8"
                        onClick={() => setOpenFaqIndex(openFaqIndex === index ? null : index)}
                        aria-expanded={openFaqIndex === index}
                      >
                        {item.question}
                        <motion.span 
                          className="absolute right-0 top-1/2 -translate-y-1/2 w-3 h-3 md:w-4 md:h-4 flex items-center justify-center"
                          animate={{ rotate: openFaqIndex === index ? 180 : 0 }}
                          transition={{ duration: 0.2, ease: "easeInOut" }}
                        >
                          <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1.5L6 6.5L11 1.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </motion.span>
                      </button>
                      
                      <div className="overflow-hidden">
                        <motion.div
                          className="overflow-hidden"
                          initial={false}
                          animate={{
                            maxHeight: openFaqIndex === index ? '500px' : '0px',
                            opacity: openFaqIndex === index ? 1 : 0,
                            marginTop: openFaqIndex === index ? '0' : '0',
                            marginBottom: openFaqIndex === index ? '0' : '0',
                          }}
                          transition={{
                            duration: 0.3,
                            ease: "easeInOut"
                          }}
                        >
                          <div className="pb-5 md:pb-6 text-[#787c87] font-light font-geist whitespace-pre-line">
                            {item.answer.split('\n').map((paragraph, i) => (
                              <p key={i} className="mb-2 last:mb-0 text-sm md:text-base">
                                {paragraph}
                              </p>
                            ))}
                          </div>
                        </motion.div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 5: CTA */}
      <section className="h-auto min-h-[500px] md:h-[750px] flex items-center justify-center bg-[#010003] text-white px-4 relative overflow-visible py-20">
        {/* Gradient Blur Effect */}
        <div className="absolute inset-0 z-0 pointer-events-none -top-1/4">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] md:w-[800px] h-[300px] md:h-[800px] rounded-full bg-gradient-to-r from-white/10 via-[#d5d8f6]/10 to-white/10 blur-3xl opacity-50"></div>
        </div>
        <div className="absolute inset-0 bg-[#010003] -z-10"></div>
        <div className="relative z-10 text-center w-full max-w-[1000px]">
          <h2 className="font-calsans font-bold text-[30px] md:text-[56px] tracking-[-0.02em] leading-[1.3] md:leading-[1.5] bg-gradient-to-r from-[#d5d8f6] from-30% via-white via-50% to-[#d5d8f6] to-70% bg-clip-text text-transparent text-center mb-6 md:mb-8 mx-auto">
            Noch nicht sicher wie <br className="hidden md:block"/> Sie KI einsetzen können?
          </h2>
          <p className="text-[#787c87] text-sm md:text-base mb-8 md:mb-12 max-w-[600px] mx-auto">
            Machen Sie unsere kostenlose KI-Online Audit und entdecken Sie, <br className="hidden md:block"/>wie KI Ihr Unternehmen in verschiedenen Bereichen unterstützen kann.
          </p>
          
          <div className="flex flex-row justify-center gap-4 mx-auto max-w-[500px]">
            <a 
              href="https://audit.blcks.at" 
              target="_blank"
              rel="noopener noreferrer"
              className="transition-shadow duration-300 group inline-flex items-center relative justify-center rounded-full tracking-tight h-10 text-sm md:text-base px-[18px] bg-white text-black font-medium w-full sm:w-fit shadow-[0px_6px_16px_rgba(255,255,255,.2)] hover:shadow-[0px_6px_56px_0px_rgba(255,255,255,.4),0px_4px_15px_0px_rgba(0,0,0,.2)]"
            >
              <span 
                className="pointer-events-none absolute inset-0 z-0 rounded-[inherit] bg-gradient-to-r from-white to-gray-200 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                aria-hidden="true"
              />
              <span className="relative z-10">KI-Online Audit</span>
              <img 
                src={buttonarrowright} 
                alt="" 
                className="relative z-10 ml-1.5 h-5 w-5 shrink-0" 
                width={16} 
                height={16} 
              />
            </a>
            
            <Link 
              to="/contact"
              className="transition-shadow duration-300 group inline-flex items-center relative justify-center rounded-full tracking-tight h-10 text-sm md:text-base px-[18px] bg-white text-black font-medium w-full sm:w-fit shadow-[0px_6px_16px_rgba(255,255,255,.2)] hover:shadow-[0px_6px_56px_0px_rgba(255,255,255,.4),0px_4px_15px_0px_rgba(0,0,0,.2)]"
            >
              <span 
                className="pointer-events-none absolute inset-0 z-0 rounded-[inherit] bg-gradient-to-r from-white to-gray-200 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                aria-hidden="true"
              />
              <span className="relative z-10">Kontaktiere uns</span>
              <img 
                src={buttonarrowright} 
                alt="" 
                className="relative z-10 ml-1.5 h-5 w-5 shrink-0" 
                width={16} 
                height={16} 
              />
            </Link>
          </div>
        </div>
      </section>
      
      <FooterWrapper />
    </div>
  );
};

export default Pricing;